import Chocolat from 'chocolat';

(() => {
    Chocolat(document.querySelectorAll('.chocolat-image'), {
        loop: true,
        imageSize: 'scale-down',
    })

})();
